import React, { Component } from "react";
import { Card, Button, Row, Col, Alert } from "react-bootstrap";
import { FaCheck } from "react-icons/fa";
import api from "../../services/api";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Editor from '@monaco-editor/react';

class ProgramaConfiguracoes extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            saving: false,
            error: '',
            configuracoesJson: '{}',
            configuracoesJsonError: '',
        };
    }

    componentDidMount() {
        this.carregarConfiguracoes();
    }

    carregarConfiguracoes = () => {
        const { programaId } = this.props;

        if (!programaId) {
            this.setState({ loading: false, error: 'ID do programa não informado' });
            return;
        }

        this.setState({ loading: true, error: '' });

        api.get(`/programas/${programaId}/`)
            .then(response => {
                const configuracoes = response.data.configuracoes;
                this.setState({
                    configuracoesJson: configuracoes ? JSON.stringify(configuracoes, null, 4) : '{}',
                    loading: false,
                    error: '',
                });
            })
            .catch(error => {
                let erro_msg = 'Erro ao carregar configurações do programa';

                if (error.response && error.response.status === 500) {
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                } else if (error.response && error.response.status === 403) {
                    erro_msg = 'Você não tem permissão para acessar essa área';
                }

                this.setState({
                    loading: false,
                    error: erro_msg,
                });
            });
    };

    handleConfiguracoesJsonChange = (value) => {
        this.setState({ configuracoesJson: value || '', configuracoesJsonError: '' });
    };

    validarJson = () => {
        try {
            JSON.parse(this.state.configuracoesJson);
            return true;
        } catch (e) {
            this.setState({ configuracoesJsonError: 'JSON inválido. Verifique a sintaxe.' });
            return false;
        }
    };

    salvarConfiguracoes = async () => {
        if (!this.validarJson()) {
            return;
        }

        const { programaId } = this.props;

        this.setState({ saving: true });

        let configuracoesObj = null;
        try {
            configuracoesObj = JSON.parse(this.state.configuracoesJson);
        } catch (e) {
            configuracoesObj = {};
        }

        try {
            await api.put(`/programas/${programaId}/`, {
                configuracoes: configuracoesObj,
            });

            const MySwal = withReactContent(Swal);
            MySwal.fire({
                title: <p>Configurações salvas com sucesso</p>,
                icon: 'success',
                showCloseButton: true,
            });

            this.setState({ saving: false });

        } catch (error) {
            let erro_msg = 'Erro ao salvar configurações, tente novamente';

            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            } else if (error.response && error.response.status === 400) {
                const campos = error.response.data;
                if (campos.configuracoes) {
                    this.setState({ configuracoesJsonError: campos.configuracoes });
                }
            }

            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            });

            this.setState({ saving: false });
        }
    };

    render() {
        const { 
            loading, 
            saving,
            error, 
            configuracoesJson,
            configuracoesJsonError,
        } = this.state;

        if (loading) {
            return (
                <Card className="cardDestaque">
                    <Card.Body>
                        <Row>
                            <Col xs={12}>
                                <p>Carregando...</p>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            );
        }

        if (error) {
            return (
                <Card className="cardDestaque">
                    <Card.Body>
                        <Alert variant="warning">{error}</Alert>
                    </Card.Body>
                </Card>
            );
        }

        return (
            <Card className="cardDestaque">
                <Card.Body>
                    <Row className="align-items-center mb-3">
                        <Col sm={6} lg={6}>
                            <h4>Configurações do Programa</h4>
                        </Col>
                    </Row>

                    {configuracoesJsonError && (
                        <Alert variant="danger" className="py-2 mb-3">{configuracoesJsonError}</Alert>
                    )}

                    <Editor
                        height="500px"
                        defaultLanguage="json"
                        value={configuracoesJson}
                        onChange={this.handleConfiguracoesJsonChange}
                        theme="vs-dark"
                        options={{
                            minimap: { enabled: false },
                            fontSize: 14,
                            formatOnPaste: true,
                            formatOnType: true,
                            automaticLayout: true,
                            tabSize: 4,
                        }}
                    />

                    <Button 
                        variant="success" 
                        className="mt-3"
                        onClick={this.salvarConfiguracoes}
                        disabled={saving}
                    >
                        {saving ? (
                            <span className="spinner-border spinner-border-sm"></span>
                        ) : (
                            <>
                                <FaCheck className="me-1" /> Salvar Configurações
                            </>
                        )}
                    </Button>
                </Card.Body>
            </Card>
        );
    }
}

export default ProgramaConfiguracoes;
